import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Home202205 from '../views/Home202205.vue'
// import Project from '../views/Project.vue'
import Shop from '../views/Shop.vue'
import Policy from '../views/Policy.vue'
import Blog from '../views/Blog.vue'
import Post from '../views/Post.vue'
import CGV from '../views/CGV.vue'
import PourQui from '../views/PourQui.vue'
import StrapiBlog from '../views/StrapiBlog.vue'
import StrapiPost from '../views/StrapiPost.vue'
import Contact from '../views/Contact.vue'

import QuiSommesNous from '../views/QuiSommesNous.vue'
import NosOffres from '../views/NosOffres.vue'
import TrouverMonStyle from '../views/TrouverMonStyle.vue'

import OneOffer from '../views/OneOffer.vue'
import OneOfferProject from '../views/OneOfferProject.vue'
import OneOfferForm from '../views/OneOfferForm.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/welcome2022',
    name: 'Home202205',
    component: Home202205
  },
  {
    path: '/mon-projet',
    name: 'Project',
    component: () => import(/* webpackChunkName: "about" */ '../views/Project.vue')
    // component: Project
  },
  {
    path: '/qui-sommes-nous',
    name: 'QuiSommesNous',
    component: QuiSommesNous
  },
  {
    path: '/nos-offres',
    name: 'NosOffres',
    component: NosOffres
  },
  {
    path: '/nos-offres/:iso',
    name: 'OneOffer',
    component: OneOffer
  },
  {
    path: '/mon-projet/:iso',
    name: 'OneOfferProject',
    component: OneOfferProject
  },
  {
    path: '/mon-projet/:iso/questionnaire',
    name: 'OneOfferForm',
    component: OneOfferForm
  },
  {
    path: '/mon-projet/hortus-design',
    name: 'MonProjetHortusDesign',
    component: PourQui
  },
  {
    path: '/trouver-mon-style',
    name: 'TrouverMonStyle',
    component: TrouverMonStyle
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FAQ.vue')
  },
  {
    path: '/choix',
    name: 'PourQui',
    component: PourQui
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop
  },
  {
    path: '/noel',
    name: 'ShopNoel',
    component: Shop
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/shop/:productId',
    name: 'ShopOneProduct',
    component: Shop
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy
  },
  {
    path: '/cgv',
    name: 'CGV',
    component: CGV
  },
  {
    path: '/blog-old',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/blog-old/post/:slug',
    name: 'Post',
    component: Post
  },
  {
    path: '/blog',
    name: 'StrapiBlog',
    component: StrapiBlog
  },
  {
    path: '/blog/post/:slug',
    name: 'PostV2',
    component: StrapiPost
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '*',
    name: 'Default',
    component: Home
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(function(to, from, next) {
  const version = localStorage.getItem('lp-version')
  if (to.path === '/' && version === '202205') {
    next('/welcome2022')
    return
  }
  window.scrollTo(0, 0)
  next()
})

export default router
